var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-top",on:{"click":_vm.scrollTop}},[_c('v-icon',{staticClass:"top-icon"},[_vm._v(" mdi-arrow-up ")]),_c('div',{staticClass:"text"},[_vm._v(" ＴＯＰ ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }